export default "__VITE_ASSET__D3f1vI0d__"